import i18n from '@/i18n';
import {MedicationFoodRelation} from '@/services/graphqlHooks';

const medicationFoodRelation = {
  [MedicationFoodRelation.Other]: i18n.t('Other'),
  [MedicationFoodRelation.WithMeal]: i18n.t('With meal'),
  [MedicationFoodRelation.AfterMeal]: i18n.t('After meal'),
  [MedicationFoodRelation.BeforeMeal]: i18n.t('Before meal'),
  [MedicationFoodRelation.EmptyStomach]: i18n.t('Empty stomach'),
} as Record<MedicationFoodRelation, string>;

export default medicationFoodRelation;
